import styled from '@emotion/styled'
import { spacer, SpacerDefs, WithChildren } from '@pharmac/ui'

const NoResultsContainer = styled.div<SpacerDefs>`
  display: flex;
  background: var(--color-accent-2);
  padding: var(--spacing-large);
  border-radius: 20px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  ${spacer};
`

export const NoResults = (props: WithChildren & SpacerDefs) => {
  return <NoResultsContainer {...props}>{props.children}</NoResultsContainer>
}
